import React from 'react';
import Hidden, {HiddenProps} from '@material-ui/core/Hidden';

interface ChildrenProps {
    children: React.ReactNode;
}

type HiddenSSRProps = HiddenProps & ChildrenProps;

export const HiddenSSR = ({children, ...props}: HiddenSSRProps): JSX.Element => {
    return (
        <Hidden {...props} implementation="css">
            {children}
        </Hidden>
    );
};
